import React, { useState } from "react";

import styles from "./devRegForm.module.scss";
import authService from "../../../utils/services/authService";
import { useNavigate } from "react-router-dom";

const DeveloperRegForm = ({ user }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    if (name === "" || email === "" || password === "" || confirmPass === "") {
      console.log("Please fill in all fields");
      return;
    }
    if (!email.includes("@")) {
      console.log("Not a valid email address");
      return;
    }
    if (password !== confirmPass) {
      console.log("Passwords does not match");
      return;
    } else {
      const data = {
        name: name,
        email: email,
        password: password,
        role: "developer",
      };

      const response = await authService.registerFunction(data).then((res) => {
        return res;
      });

      if (response.success === true) {
        navigate("/login");
      } else {
        setMessage(response.message);
      }
    }
  };

  return (
    <section className={styles.formWrapper}>
      <h2 className={styles.formTitle}>We're super excited to have you!</h2>
      <p className={styles.formSubHeading}>
        Start by filling in the form below
      </p>
      {message !== "" && <p className={styles.errorMsg}>{message}</p>}
      <form action="" className={styles.form}>
        <div className={styles.formGroup}>
          <input
            required
            id="name"
            type="text"
            aria-label="Name"
            placeholder="Name *"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <input
            required
            id="email"
            type="email"
            pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
            aria-label="Email"
            placeholder="Email *"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <input
            required
            id="password"
            type="password"
            aria-label="Password"
            placeholder="Password *"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <input
            required
            id="confirmPass"
            type="password"
            placeholder="Confirm password"
            aria-label="Confirm password *"
            onChange={(e) => {
              setConfirmPass(e.target.value);
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <button
            type="submit"
            className={styles.formBtn}
            onClick={(e) => {
              submitHandler(e);
            }}
          >
            Register me
          </button>
        </div>
      </form>
    </section>
  );
};

export default DeveloperRegForm;
